import axios from "axios";

import ENV from "../../util/env-config";
import { getSessionCookie } from "../../util/common";

class Service {
  static requestConfig() {
    return {
      headers: {
        Authorization: `Bearer ${getSessionCookie()}`,
      },
    };
  }
  static getUser(id) {
    return axios.post(`${ENV.systemBase}/users/details`, { id: id }, this.requestConfig());
  }

  static getUserMetrics(id) {
    return axios.post(ENV.systemBase + "/support/list", { user_id: id }, this.requestConfig());
  }

  static searchUsers(requestData) {
    return axios.post(ENV.systemBase + "/users/search", requestData, this.requestConfig());
  }

  static getDevicesByUser(requestData) {
    return axios.post(ENV.systemBase + "/devices/find_by_user", requestData, this.requestConfig());
  }

  static reinstateUser(requestData) {
    return axios.post(ENV.systemBase + "/users/reinstate", requestData, this.requestConfig());
  }

  static setDealerDataOfficer(requestData) {
    return axios.post(ENV.dealerBaseUrl + "/agreements/data_officer/set", requestData, this.requestConfig());
  }

  static getACLRoles() {
    return axios.get(ENV.authBaseUrl + "/acl/roles/list", this.requestConfig());
  }

  static updateUser(requestData) {
    return axios.post(ENV.systemBase + "/users/update", requestData, this.requestConfig());
  }

  static deleteUser(id) {
    return axios.post(ENV.systemBase + "/users/delete", { id: id }, this.requestConfig());
  }

  static createUser(requestData) {
    return axios.post(ENV.systemBase + "/users/create", requestData, this.requestConfig());
  }

  static getBrands() {
    return axios.get(ENV.carBaseUrl + "/brands/list", this.requestConfig());
  }

  static getVersions() {
    return axios.get(ENV.systemBase + "/users/versions/list", this.requestConfig());
  }

  static getOneiPlanningMechanicList(dealer_location_id) {
    return axios.post(ENV.systemBase + "/users/pairing/onei/list", { dealer_location_id }, this.requestConfig());
  }

  static getPlanItMechanicList(dealer_location_id) {
    return axios.post(ENV.systemBase + "/users/pairing/planit/list", { dealer_location_id }, this.requestConfig());
  }

  static getDMSUsers(dealer_location_id) {
    return axios.post(ENV.systemBase + "/users/dms/users/list", { dealer_location_id }, this.requestConfig());
  }

  static updatePlanitPairing(requestData) {
    return axios.post(ENV.systemBase + "/users/pairing/planit/update", requestData, this.requestConfig());
  }

  static updateOneiPairing(requestData) {
    return axios.post(ENV.systemBase + "/users/pairing/onei/update", requestData, this.requestConfig());
  }

  static updateDMSPairing(requestData) {
    return axios.post(ENV.systemBase + "/users/pairing/dms/update", requestData, this.requestConfig());
  }

  static getUserPasswordStrength(requestData) {
    return axios.post(ENV.systemBase + "/users/password/strength", requestData, this.requestConfig());
  }

  static handleUpdateIsLeaseDevice(requestData) {
    return axios.post(ENV.systemBase + "/devices/lease/update", requestData, this.requestConfig());
  }

  static getAssignedUserCount(requestData) {
    return axios.post(ENV.appointmentApiBase + "/dayplanner/mechanics/assigned_count", requestData, this.requestConfig());
  }
}

export default Service;
